var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlamegrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 30,
    viewBox: "0 0 27 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.33352 0.31787C9.79053 -0.109843 10.4995 -0.103984 10.9565 0.32373C12.5736 1.84123 14.0911 3.47592 15.509 5.24536C16.1535 4.40165 16.8859 3.48178 17.6769 2.73181C18.1397 2.29824 18.8545 2.29824 19.3174 2.73767C21.3447 4.67117 23.0614 7.22573 24.2683 9.65139C25.4577 12.0419 26.2487 14.4851 26.2487 16.2077C26.2487 23.6839 20.4013 30 13.1244 30C5.76534 30 0 23.678 0 16.2019C0 13.952 1.04292 11.2041 2.66003 8.48544C4.29471 5.72581 6.60319 2.849 9.33352 0.31787ZM13.224 24.3753C14.7063 24.3753 16.0187 23.9651 17.255 23.1449C19.7217 21.4223 20.3838 17.9772 18.9014 15.2703C18.6378 14.7429 17.964 14.7078 17.5831 15.1531L16.1066 16.8698C15.7199 17.3151 15.0227 17.3034 14.6594 16.8405C13.6927 15.6101 11.9643 13.4129 10.9799 12.1649C10.6108 11.6962 9.90771 11.6904 9.53273 12.1591C7.55236 14.6492 6.55632 16.2194 6.55632 17.983C6.56218 21.9965 9.52687 24.3753 13.224 24.3753Z",
    fill: "#AAAAAA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlamegrey);
export default __webpack_public_path__ + "static/media/flame grey.dc14dddfd67ee203c649b3b99ddc74fc.svg";
export { ForwardRef as ReactComponent };